import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=3ec0558c&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=ts"
export * from "./Wallet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec0558c",
  null
  
)

export default component.exports